import { Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import * as media from "./media.js";
import * as height from "./height.js";
import { Discrete } from "./discrete.js";
import * as scripting from "./scripting.js";
import * as width from "./width.js";
const { delimited, either, option } = Parser;
/**
 * @public
 */
export var Media;
(function (Media) {
    Media.Height = height.Height;
    Media.Orientation = Discrete.Orientation;
    Media.Scripting = scripting.Scripting;
    Media.Width = width.Width;
    Media.ForcedColors = Discrete.ForcedColors;
    Media.Inverted = Discrete.Inverted;
    Media.PrefersColorScheme = Discrete.PrefersColorScheme;
    Media.PrefersContrast = Discrete.PrefersContrast;
    Media.PrefersReducedData = Discrete.PrefersReducedData;
    Media.PrefersReducedMotion = Discrete.PrefersReducedMotion;
    Media.PrefersReducedTransparency = Discrete.PrefersReducedTransparency;
    Media.isHeight = Media.Height.isHeight;
    Media.isWidth = Media.Width.isWidth;
    Media.isMedia = media.Media.isMedia;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-feature}
     */
    Media.parse = delimited(Token.parseOpenParenthesis, delimited(option(Token.parseWhitespace), either(Media.Height.parse, Media.Orientation.parse, Media.Scripting.parse, Media.Width.parse, Media.ForcedColors.parse, Media.Inverted.parse, Media.PrefersColorScheme.parse, Media.PrefersContrast.parse, Media.PrefersReducedData.parse, Media.PrefersReducedMotion.parse, Media.PrefersReducedTransparency.parse)), Token.parseCloseParenthesis);
})(Media || (Media = {}));
//# sourceMappingURL=index.js.map